export const LEARNING_PROFESSIONS = ['DOC', 'PHA', 'ALT', 'STO', 'STP', 'STC', 'PSY', 'PKA', 'PTA'];

export const HCP_PROFESSIONS = ['DOC', 'PHA', 'ALT', 'STO', 'STP', 'STC', 'PSY', 'JOU', 'PSY', 'OTH', 'anything'];

/**
 * User groups/professions which have the Bonus system enabled.
 *
 * Hint: STP is used as fallback for the duration of the migration to PTA and PKA
 */
export const BONUS_PROFESSIONS = ['PTA', 'PKA', 'PHA', 'STP'];
